module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget modal",
    class: {
      'hide': _vm.hide
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dismiss.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    },
    on: {
      "after-leave": _vm.activate
    }
  }, [(_vm.show) ? _c(_vm.content, {
    tag: "component",
    attrs: {
      "args": _vm.args
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da916c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Widget.vue
// module id = 467
// module chunks = 234